<ion-header>
  <ion-toolbar color="primary">
    <ion-title>
      <h1>Advanced Filter</h1>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ComparablesFilter__Content pt-3">
  <!-- Description -->
  <p class="p-3" [innerHTML]="comparablesFilterDescription"></p>

  <!-- Form Fields -->
  <form
    [formGroup]="filterForm"
    class="p-3 d-flex flex-wrap justify-content-between"
  >
    @for (filterName of filterControlData; track filterName) {
      @if (isDateRangeFilter(filterName.name)) {
        <ion-item class="ComparablesFilter__RadioGroupWrapper">
          <ion-radio-group
            [formControlName]="filterName.name"
            class="ComparablesFilter__RadioGroup"
          >
            <ion-label
              class="ComparablesFilter__RadioGroupLabel"
              [innerHTML]="filterName.label"
            ></ion-label>
            @for (
              comparablesRangeOption of comparablesRangeOptions;
              track comparablesRangeOption
            ) {
              <ion-radio
                class="ComparablesFilter__Radio"
                [value]="comparablesRangeOption.value"
                labelPlacement="end"
                >{{ comparablesRangeOption.label }}</ion-radio
              >
            }
          </ion-radio-group>
        </ion-item>
      } @else if (isMaxYearBuiltFilter(filterName.name)) {
        <ion-item class="ComparablesFilter__RangeWrapper">
          <div class="ComparablesFilter__Section">
            <label class="ComparablesFilter__SectionLabel">Built After</label>
            <span [innerHTML]="filterForm.value.minYearBuilt"></span>
          </div>
          <div class="ComparablesFilter__Section">
            <ion-range
              [min]="defaultMinYearBuilt"
              [max]="currentYear"
              [dualKnobs]="true"
              [pin]="true"
              [ticks]="true"
              (ionChange)="onRangeChange($event)"
              [value]="{
                lower: filterForm.value.minYearBuilt,
                upper: filterForm.value.maxYearBuilt,
              }"
            ></ion-range>
          </div>
          <div class="ComparablesFilter__Section">
            <label class="ComparablesFilter__SectionLabel">Built Before</label>
            <span [innerHTML]="filterForm.value.maxYearBuilt"></span>
          </div>
        </ion-item>
      } @else if (isNotMinYearBuiltFilter(filterName.name)) {
        <div
          class="ComparablesFilter__Field"
          [ngClass]="{
            'ComparablesFilter__Field--Max': $index % 2 !== 0,
            ComparablesFilter__PropertyType: filterName.name === 'propertyType',
          }"
        >
          @if (filterName.name === 'propertyType') {
            <ion-item>
              <ion-select
                [formControlName]="filterName.name"
                multiple
                [placeholder]="filterName.label"
              >
                @for (propertyType of propertyTypes; track propertyType) {
                  <ion-select-option [value]="propertyType">{{
                    propertyType
                  }}</ion-select-option>
                }
              </ion-select>
            </ion-item>
          } @else {
            <ion-input
              fill="solid"
              label-placement="floating"
              [name]="filterName.name"
              [type]="filterName.name === 'zip' ? 'text' : 'number'"
              [formControlName]="filterName.name"
              [placeholder]="filterName.label"
              [label]="filterName.label"
            ></ion-input>
          }
        </div>
      }
    }
  </form>
</ion-content>

<!-- Action Row-->
<ion-footer>
  <ion-toolbar>
    <ion-buttons class="col p-2 d-flex justify-content-end">
      <ion-button
        class="ComparablesFilter__Button"
        fill="outline"
        (click)="clearFilter()"
        [innerHTML]="'Clear Form'"
      ></ion-button>
      <ion-button
        class="ComparablesFilter__Button"
        fill="outline"
        (click)="cancel()"
        [innerHTML]="'Cancel'"
      ></ion-button>
      <ion-button
        class="ComparablesFilter__Button"
        fill="solid"
        color="primary"
        (click)="saveFilter()"
        [innerHTML]="'Apply'"
      ></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
